import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import Message from 'components/Message';

export const messages = defineMessages({
  charactersRemaining: {
    id: 'edit-section.characters-remaining',
    defaultMessage: '{remaining, plural, one {# character} other {# characters}} remaining',
  },
  charactersRemainingWithMaxLength: {
    id: 'edit-section.characters-remaining-with-max-length',
    defaultMessage: '{remaining, number}/{maxLength, number} characters remaining',
  },
});

const CharactersRemaining = ({ length, value, showMaxLength, ...rest }) => {
  const message = showMaxLength ? messages.charactersRemainingWithMaxLength : messages.charactersRemaining;
  return <Message message={message} values={{ maxLength: length, remaining: length - value.length }} {...rest} />;
};

CharactersRemaining.propTypes = {
  length: PropTypes.number,
  value: PropTypes.string,
  showMaxLength: PropTypes.bool,
};

export default CharactersRemaining;
